var __assign =
  (this && this.__assign) ||
  function () {
    __assign =
      Object.assign ||
      function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i]
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p]
        }
        return t
      }
    return __assign.apply(this, arguments)
  }
var __rest =
  (this && this.__rest) ||
  function (s, e) {
    var t = {}
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p]
    if (s != null && typeof Object.getOwnPropertySymbols === 'function')
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]]
      }
    return t
  }
import classNames from 'classnames'
import omit from 'lodash/omit'
import React from 'react'
export var ODFullLayout = function (props) {
  var children = props.children,
    style = props.style,
    className = props.className,
    remaining = __rest(
      props,
      // TODO: Re-enable later.
      // const {
      //   state: {
      //     def: { screenMaxWidth },
      //   },
      // } = useGlobalContext()
      ['children', 'style', 'className']
    )
  // TODO: Re-enable later.
  // const {
  //   state: {
  //     def: { screenMaxWidth },
  //   },
  // } = useGlobalContext()
  var screenMaxWidth = undefined
  var cn = classNames(
    'min-h-screen  od-contents mx-auto',
    className !== null && className !== void 0 ? className : '',
    {
      'min-w-screen': screenMaxWidth === undefined || screenMaxWidth === Infinity,
    }
  )
  var styleWidth = omit({
    maxWidth: screenMaxWidth,
  })
  return React.createElement(
    'div',
    __assign({ className: cn, style: __assign(__assign({}, style), styleWidth) }, remaining),
    children
  )
}
//# sourceMappingURL=ODFullLayout.js.map
